import { render } from "./PackBagTask.vue?vue&type=template&id=77bf080a"
import script from "./PackBagTask.vue?vue&type=script&lang=js"
export * from "./PackBagTask.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__